import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import logowide from "../Images/logo-wide.png";
import "../CSS/Navbar.css"; // Import the CSS file
import { NavLink } from "react-router-dom";
const CustomNavDropdown = ({ title, children }) => {
  const [showDropdown, setShowDropdown] = useState(false);

  // Handle mouse enter and leave events
  const handleMouseEnter = () => {
    setShowDropdown(true);
  };

  const handleMouseLeave = () => {
    setShowDropdown(false);
  };

  // Cleanup when component unmounts
  useEffect(() => {
    return () => {
      setShowDropdown(false); // Reset dropdown state on unmount
    };
  }, []);

  return (
    <NavDropdown
      title={title}
      id="basic-nav-dropdown"
      show={showDropdown}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
    </NavDropdown>
  );
};

const Navbar1 = () => {
  return (
    <Navbar
      expand="lg"
      className="bg-white sticky-top fs-6 fw-semibold text-black"
    >
      <Container>
        <Navbar.Brand href="#home">
          <img
            src={logowide}
            width="80"
            height="80"
            className="d-inline-block align-top"
            alt="logo.."
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="justify-content-center">
            <Nav.Link as={NavLink} to="/" className="nav-link">
              Home
            </Nav.Link>
            <Nav.Link as={NavLink} to="/About" className="nav-link">
              About
            </Nav.Link>
            <Nav.Link as={NavLink} to="/ExecutiveBody" className="nav-link">
              Executive Body
            </Nav.Link>
            <Nav.Link as={NavLink} to="/Membership" className="nav-link">
              Membership
            </Nav.Link>
            <CustomNavDropdown title="Important Links">
              <NavDropdown.Item
                as={NavLink}
                to="/HighCourts"
                className="border-0"
              >
                High Court Links
              </NavDropdown.Item>
              <NavDropdown.Item
                href="https://vcourts.gov.in/virtualcourt/"
                target="_blank"
              >
                Pay Your Traffic Challan
              </NavDropdown.Item>
              <NavDropdown.Item href="https://main.sci.gov.in/" target="_blank">
                Supreme Court Link
              </NavDropdown.Item>
              <NavDropdown.Item
                href="https://dehradun.dcourts.gov.in/"
                target="_blank"
              >
                District Court Dehradun
              </NavDropdown.Item>
              <NavDropdown.Item
                href="https://ecourts.gov.in/ecourts_home/"
                target="_blank"
              >
                ECourt Service
              </NavDropdown.Item>
            </CustomNavDropdown>
            <Nav.Link as={NavLink} to="/Aims&Obj" className="nav-link">
              Aims & Objective
            </Nav.Link>
            <Nav.Link as={NavLink} to="/ExMembers" className="nav-link">
              Ex Members
            </Nav.Link>
            <NavDropdown title="Resources" id="basic-nav-dropdown">
              <NavDropdown.Item as={NavLink} to="/Library">
                Library
              </NavDropdown.Item>
            </NavDropdown>
            <NavDropdown title="Gallery" id="basic-nav-dropdown">
              <NavDropdown.Item
                as={NavLink}
                to="/MediaGallery"
                className="border-0"
              >
                Media Gallery
              </NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/EventGallery">
                Event Gallery
              </NavDropdown.Item>
            </NavDropdown>
            <Nav.Link as={NavLink} to="/Contact" className="nav-link">
              Contact
            </Nav.Link>
            {/* <Nav.Link as={NavLink} to="/FindAdvocate" className="nav-link">
              Find Advocate
            </Nav.Link> */}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navbar1;
